var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$root.reload)?_c('div',{attrs:{"id":"app"}},[_c('home',{attrs:{"page-suffix":_vm.pageSuffix}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }